module.exports = __webpack_public_path__ + "img/reviews.32036cc8.png";